(function($) {
    "use strict";
    /**
     * Passthrough wrapper for Ladda Buttons to detect and disable in IE8 and below
     * @param el
     * @returns {{start: start, stop: stop, setProgress: setProgress}}
     * @constructor
     */
    FG.Ladda = function(el)
    {

        var laddaBtn = null;

        /**
         * Returns the current IE version or -1 if not IE
         * @returns {number}
         */
        function getInternetExplorerVersion()
        {
            var rv = -1; // Return value assumes failure.
            if (navigator.appName == 'Microsoft Internet Explorer')
            {
                var ua = navigator.userAgent;
                var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
                if (re.exec(ua) != null)
                    rv = parseFloat( RegExp.$1 );
            }
            return rv;
        }

        var IEVersion = getInternetExplorerVersion();

        if (IEVersion == -1 || IEVersion > 8.0) {
            laddaBtn = Ladda.create(el);
        }

        return {
            /**
             * Starts the ladda button loading
             */
            start : function() {
                if (laddaBtn !== null) {
                    laddaBtn.start();
                }
            },
            /**
             * Stops the ladda button loading
             */
            stop : function() {
                if (laddaBtn !== null) {
                    laddaBtn.stop();
                }
            },
            /**
             * Sets the percentage of the Ladda button
             * @param value Decimal equivalent of percentage
             */
            setProgress : function(value) {
                if (laddaBtn !== null) {
                    laddaBtn.setProgress(value);
                }
            }
        };
    };
})(jQuery);